<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="充电站:" :label-width="60">
				<Select filterable placeholder="站点列表" style="width: 180px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.OrderNo" placeholder="订单号">
				<span slot="prepend">订单单号</span>
				</Input>
			</FormItem>
			<FormItem>
				<Input type="text" style="width: 160px;" v-model="formInline.CarNo" placeholder="车牌号">
				<span slot="prepend">车牌号</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSearch('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">导出文件</Button>
			</FormItem>
		</Form>
		<Table :columns="tableColumns" :data="tableData" :height="tableHeight" ref="tablePushRecord"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getPushRecordUrl" @listData='getTableData'></MyPage>
	</div>
</template>

<script>
	// import dateFormat from '../../../../public/js/comm.js'
	// import expandRow from './OccupyOrderExpend.vue';
	import webapi from '../../../webapi.js';
	import {
		mapState,
		// mapGetters,
		// mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				getPushRecordUrl: webapi.base_api_url + '/Order/GetParkingPushRecord',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				tableHeight: "650",
				// modal: {
				// 	Title: "设备信息添加",
				// 	type: "addDevice"
				// },
				BreadcrumbList: ['订单记录', '>>', '道闸推送记录'],
				formInline: {
					StationId: 0,
					OrderNo: '',
					CarNo: '',
				// 	TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
				// 	TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
				// 	TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
				// 	EquipmentNo: '',
				// 	PhoneNo: '',
				},
				//table标题数据
				tableColumns: [{
					// 	type: 'expand',
					// 	width: 50,
					// 	render: (h, params) => {
					// 		return h(expandRow, {
					// 			props: {
					// 				row: params.row
					// 			}
					// 		})
					// 	}
					// }, {
						title: '订单单号',
						key: 'OrderNo',
						width: 180
					}, {
						title: '车牌号',
						key: 'CarNo',
						width: 110
					}, {
						title: '道闸类型',
						key: 'ParkingTypeDesc',
						minWidth: 100,
					},
					{
						title: '优惠类型',
						key: 'CouponTypeDesc',
						minWidth: 100,
					},
					{
						title: '优惠额度',
						key: 'ConponValue',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.ConponValue + (params.row.CouponType == 0 ? '元' : params.row.CouponType == 1 ? "分钟" : "")
							);
						}
					},
					{
						title: '推送状态',
						key: 'ResultDesc',
						minWidth: 100,
					}, {
						title: '结果信息',
						key: 'ResponseMsg',
						minWidth: 100,
					},{
						title: '推送时间',
						key: 'PushTime',
						width: 110,
					},
					// {
					// 	title: '项目编码',
					// 	key: 'ProjectCode',
					// 	minWidth: 100,
					// },
					{
						title: '车场编码',
						key: 'ParkingId',
						minWidth: 100,
					},
					{
						title: '道闸名称',
						key: 'ParkingName',
						minWidth: 100,
					},
					{
						title: '所属场站',
						key: 'StationName',
						minWidth: 100,
					},
					{
						title: '道闸订单号',
						key: 'ParkOrderNo',
						minWidth: 100,
						tooltip: true,
					// 	render: (h, params) => {
					// 		const text = params.row.ParkOrderNo;
					// 		return h('Tooltip', {
					// 			props: {
					// 				content: text,
					// 				// theme: 'light',
					// 				maxWidth: 200,
					// 			}
					// 		}, [
					// 			h('div', {
					// 				style: {
					// 					overflow: 'hidden',
					// 					textOverflow: 'ellipsis',
					// 					whiteSpace: 'nowrap',
					// 					width: '100px',
					// 				}
					// 			}, text)
					// 		], text);
					// 	}
					},
					{
						title: '请求报文',
						key: 'RequestData',
						minWidth: 100,
						tooltip: true,
						// render: (h, params) => {
						// 	const text = params.row.RequestData;
						// 	return h('Tooltip', {
						// 		props: {
						// 			content: text,
						// 			// theme: 'light',
						// 			maxWidth: 200,
						// 		}
						// 	}, [
						// 		h('div', {
						// 			style: {
						// 				overflow: 'hidden',
						// 				textOverflow: 'ellipsis',
						// 				whiteSpace: 'nowrap',
						// 				width: '100px',
						// 			}
						// 		}, text)
						// 	], text);
						// }
					},
					{
						title: '应答报文',
						key: 'ResponseData',
						minWidth: 100,
						tooltip: true,
						// render: (h, params) => {
						// 	const text = params.row.ResponseData;
						// 	return h('Tooltip', {
						// 		props: {
						// 			content: text,
						// 			// theme: 'light',
						// 			maxWidth: 200,
						// 		}
						// 	}, [
						// 		h('div', {
						// 			style: {
						// 				overflow: 'hidden',
						// 				textOverflow: 'ellipsis',
						// 				whiteSpace: 'nowrap',
						// 				width: '100px',
						// 			}
						// 		}, text)
						// 	], text);
						// }
					},
				],
				tableData: []
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSearch();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					OrderNo: _this.formInline.OrderNo,
					CarNo: _this.formInline.CarNo,
					// TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(
					// 	new Date(_this.formInline.TimeBegin), 'yyyy-MM-dd'),
					// TimeEnd: _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(
					// 	new Date(_this.formInline.TimeEnd), 'yyyy-MM-dd'),
					// EquipmentNo: _this.formInline.EquipmentNo,
					// MemberName: _this.formInline.MemberName,
					// PhoneNo: _this.formInline.PhoneNo,
					// CouponName: _this.formInline.CouponName,
					// PaymentWay: _this.formInline.PaymentWay,
				}
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			// handleChange(date, type) {
			// 	console.log("日期改变：", date, type);
			// 	this.formInline.TimeBegin = date[0];
			// 	this.formInline.TimeEnd = date[1];
			// },
			exportFile: function() {
				this.$refs.tablePushRecord.exportCsv({
					filename: '道闸推送记录',
					columns: this.tableColumns,
					data: this.tableData.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.PushTime = '\t' + (k.PushTime || '');
						// k.OrderTime = '\t' + (k.OrderTime || '');
						// k.StartTime = '\t' + (k.StartTime || '');
						// k.EndTime = '\t' + (k.EndTime || '');
						// k.RefundTime = '\t' + (k.RefundTime || '');
						return k;
					})
				})
			},
			getTableData: function(data) {
				console.log(data)
				this.tableData = data.Data.List
			},
			handleSearch: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			}
		},
	}
</script>

<style>
</style>